// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#content-image-dropzone[data-v-61f6075d]{min-height:126px}#content-image-add-files[data-v-61f6075d]{padding-top:40px}.dz-uploaded-file[data-v-61f6075d]{cursor:default}", ""]);
// Exports
module.exports = exports;
